<template>
  <div>
    <CCard v-if="print">
      <CCardHeader>
        <CRow>
          <CCol class="align-self-center">
            <label class="mb-0 font-lg font-weight-bold">Analysis</label>
            <CButton @click="csvFormat" class="text-white ml-2" color="info" size="sm"
                     v-c-tooltip="{content: 'CSV format', active:false }">
              <CIcon height="12" name="cil-info"/>
            </CButton>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CCollapse :show="csv" class="mb-2">
          <CRow>
            <CCol class="text-center">
              <img src="@/assets/img/analysisTable.png"
                   style="box-shadow: 0 4px 16px 0 rgba(0,0,0,0.2);" width="95%">
            </CCol>
          </CRow>
          <CRow class="mt-4 pl-2 pr-2">
            <CCol>
              <CCard>
                <CCardHeader color="danger" textColor="white">
                  <strong>RED (MANDATORY)</strong>
                </CCardHeader>
                <CCardBody style="min-height: 160px">
                  <CRow>
                    <CCol>
                      <strong class="font-lg mr-1">abc</strong> is the code for exam set
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <strong class="font-lg mr-1">10</strong> is the full score of the exam set
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <strong class="font-lg">1111111</strong> is the course code of exam set
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <strong class="font-lg">1</strong> is the section of examinees
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <strong class="font-lg">3, 2, ...</strong> are the correct answer of each item
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol>
            <CCol>
              <CCard>
                <CCardHeader color="info" textColor="white"><strong>BLUE (MANDATORY)</strong></CCardHeader>
                <CCardBody style="min-height: 160px">
                  <CRow>
                    <CCol>
                      <strong>7, 6, 4, ...</strong> are the score of students
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol>
            <CCol>
              <CCard>
                <CCardHeader color="success" textColor="white"><strong>GREEN</strong></CCardHeader>
                <CCardBody style="min-height: 160px">
                  <CRow>
                    <CCol>
                      <strong>3, 2, 4, 2, ...</strong> are the answers choice that each student answered
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
          <hr>
        </CCollapse>
        <form @submit.prevent="sendToAnalysis" enctype="multipart/form-data">
          <label class="mb-4">Accepted only CSV file</label> <br>
          <input @change="selectFile" class="mb-4" multiple ref="files" type="file"/> <br>
          <input :value="false" class="mr-1" id="save" name="save" type="checkbox" v-model="save">
          <label for="save">Analyze then Save the analysis result </label> <br>
          <CButton
              :class="fileTypeValidation ? 'notAllowToAnalyze':'allowToAnalyze'"
              :disabled="fileTypeValidation"
              color="success"
              type="submit"
          >
            Analyze
          </CButton>
        </form>
      </CCardBody>
    </CCard>
    <analytic-report
        :results="results"
        @printPDF="printPDF"
        id="test"
        v-if="results.exam !== undefined"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex"
import AnalyticReport from "@/components/document/AnalyticReport";

export default {
  name: "MainExamAnalysis",
  components: {AnalyticReport},
  data() {
    return {
      file: {},
      save: false,
      print: true,
      csv: false
    }
  },
  computed: {
    ...mapGetters({
      results: "examset/getAnalysisResult"
    }),
    fileTypeValidation() {
      // check file type
      // const isCSV = file.mimetype === 'text/csv';
      // const isExcel = file.mimetype === 'application/vnd.ms-excel'
      // if(!isCSV && !isExcel){
      //   return next(new ErrorResponse('Invalid file type', 400));
      // }
      if (this.file.type !== "text/csv" && this.file.type !== "application/vnd.ms-excel") {
        // alert(this.file.type)
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    csvFormat() {
      this.csv = !this.csv
    },
    printPDF() {
      this.print = false
      this.$store.commit("printPDF", true)
      setTimeout(() => {
        window.print()
        setTimeout(() => {
          this.print = true,
              this.$store.commit("printPDF", false)
        }, 100)
      }, 200)
    },
    selectFile() {
      this.file = this.$refs.files.files[0];
    },
    deleteFile() {
      this.file = '';
    },
    sendToAnalysis() {
      if (this.save) {
        this.$store.dispatch('examset/onExamsetAnalysisThenSave', {file: this.file});
      } else if (!this.save) {
        this.$store.dispatch('examset/onExamsetAnalysisThenNotSave', {file: this.file});
      }
    },
  }
}
</script>

<style scoped>
.inputCSV {
  background-color: red;
}

table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
}

.allowToAnalyze {
  cursor: pointer;
}

.notAllowToAnalyze {
  cursor: not-allowed;
}
</style>
